import { IItem } from "../types/common.interface";
import convertGregorianToJalali from "../utils/convertGregorianToJalali";

export const GENDER: IItem[] = [
  { name: "male", value: "MALE" },
  { name: "feMale", value: "FEMALE" },
];
export const SCHOOL_GENDER: IItem[] = [
  { name: "boyish", value: "MALE" },
  { name: "girlish", value: "FEMALE" },
  { name: "mixed", value: "MIXED" },
];
export const STUDENT_GENDER: IItem[] = [
  { name: "boy", value: "MALE" },
  { name: "girl", value: "FEMALE" },
];
export const MARITAL: IItem[] = [
  { name: "single", value: "SINGLE" },
  { name: "married", value: "MARRIED" },
];
export const APPROVE_STATUS: IItem[] = [
  { name: "approved", value: true },
  { name: "pending", value: false },
];

export const GRADE: IItem[] = [
  { _id: "0", name: "prep", value: "0" },
  { _id: "1", name: "firstGrade", value: "1" },
  { _id: "2", name: "secondGrade", value: "2" },
  { _id: "3", name: "thirdGrade", value: "3" },
  { _id: "4", name: "fourthGrade", value: "4" },
  { _id: "5", name: "FifthGrade", value: "5" },
  { _id: "6", name: "sixthGrade", value: "6" },
  { _id: "7", name: "seventhGrade", value: "7" },
  { _id: "8", name: "eighthGrade", value: "8" },
  { _id: "9", name: "ninthGrade", value: "9" },
  { _id: "10", name: "tenthGrade", value: "10" },
  { _id: "11", name: "eleventhGrade", value: "11" },
  { _id: "12", name: "twelveGrade", value: "12" },
];
export const CYCLE: IItem[] = [
  { _id: "0", name: "days_30", value: 30 },
  { _id: "1", name: "days_90", value: 90 },
  { _id: "2", name: "days_120", value: 120 },
];

export const FIELD: IItem[] = [
  { _id: "1", value: "1", name: "mathematicalPhysics" },
  { _id: "2", value: "2", name: "science" },
  { _id: "3", value: "3", name: "humanities" },
  { _id: "4", value: "4", name: "Vocational" },
  { _id: "5", value: "5", name: "workAndKnowledge" },
  { _id: "5", value: "5", name: "otherFields" },
];
export const ABSENT_STATUS: IItem[] = [
  {
    _id: "1",
    value: "WITHOUT_SERVICE",
    name: "The_service_has_not_started",
  },
  {
    _id: "2",
    value: "DRIVER_START_SERVICE",
    name: "The_driver_started_the_service",
  },
  {
    _id: "3",
    value: "DRIVER_ARIVED_STUDENT_HOME",
    name: "The_driver_is_ready_to_pick_up_the_student_from_home",
  },
  {
    _id: "4",
    value: "STUDENT_PICKEDUP_FROM_HOME",
    name: "The_student_got_into_the_car_from_home.",
  },
  {
    _id: "1",
    value: "STUDENT_AT_SCHOOL",
    name: "The_student_arrived_at_school",
  },
  {
    _id: "5",
    value: "DRIVER_START_PICKUP_STUDENT_FROM_SCHOOL",
    name: "The_driver_is_ready_to_pick_up_the_student_from_school",
  },
  {
    _id: "6",
    value: "STUDENT_PICKEDUP_FROM_SCHOOL",
    name: "The_student_got_into_the_car_from_school",
  },
  {
    _id: "7",
    value: "STUDENT_ARIVED_STUDENT_HOME",
    name: "The_student_arrived_home",
  },
  {
    _id: "8",
    value: "STUDENT_ABSENT",
    name: "The_student_is_absent",
  },
  {
    _id: "9",
    value: "DRIVER_ABSENT",
    name: "The_driver_is_absent",
  },
];

export const ABSENT_TYPE = [
  { _id: "STUDENT", value: "STUDENT", name: "The_student_is_absent" },
  { _id: "DRIVER", value: "DRIVER", name: "The_driver_is_absent" },
];
export const HAS_FACTOR = [
  { _id: "TRUE", value: true, name: "has_factor" },
  { _id: "FALSE", value: false, name: "has_not_factor" },
];

export const ABSENT_ISCHECKED = [
  { _id: "CHECKED", value: true, name: "checked" },
  { _id: "NOT_CHECKED", value: false, name: "notChecked" },
];

export const FINANCIAL_GROUP_TYPE = [
  { _id: "student", value: "student", name: "studentFinancialGroup" },
  { _id: "company", value: "company", name: "companyFinancialGroup" },
];
export const INVOICES_STATUS = [
  { _id: "PAID", value: "PAID", name: "payed" },
  { _id: "UN_PAID", value: "UN_PAID", name: "notPayed" },
];
export const GATEWAY = [
  { _id: "SADERAT", value: "saderat", name: "saderatGateway" },
  { _id: "ZARINPAL", value: "zarinpal", name: "zarinpalGateway" },
];
export const gender: IItem[] = [
  { name: "male", value: "MALE" },
  { name: "feMale", value: "FEMALE" },
];
export const marital: IItem[] = [
  { name: "single", value: "SINGLE" },
  { name: "married", value: "MARRIED" },
];

export const TRANSACTION_REASON = [
  {
    _id: "SERVICE_SUBSCRIPTION",
    value: "SERVICE_SUBSCRIPTION",
    name: "Pay_for_the_service",
  },
  {
    _id: "SERVICE_SUBSCRIPTION_FROM_WALLET",
    value: "SERVICE_SUBSCRIPTION_FROM_WALLET",
    name: "Pay_for_the_service_from_wallet ",
  },
  {
    _id: "SERVICE_SUBSCRIPTION_COMMISSION",
    value: "SERVICE_SUBSCRIPTION_COMMISSION",
    name: "Receive_service_commission",
  },
];

export const TRANSACTION_STATUS = [
  {
    _id: "SUCCESS",
    value: "SUCCESS",
    name: "successfulTransaction",
  },
  {
    _id: "FAILED",
    value: "FAILED",
    name: "unSuccessfulTransaction",
  },
  {
    _id: "PENDING",
    value: "PENDING",
    name: "pendingTransaction",
  },
];
export const WITHDRAWAL_STATUS = [
  {
    _id: "SUCCESS",
    value: "SUCCESS",
    name: "approved",
  },
  {
    _id: "REJECT",
    value: "REJECT",
    name: "rejected",
  },
  {
    _id: "PENDING",
    value: "PENDING",
    name: "pending",
  },
  {
    _id: "SEND2BANK",
    value: "SEND2BANK",
    name: "send2Bank",
  },
];

export const PAY_TYPE = [
  { _id: "isDeposit", value: true, name: "deposit" },
  { _id: "isDeposit", value: false, name: "withdrawal" },
];
export const RECEIVER_TYPE = [
  { _id: "TAX", value: "TAX", name: "tax" },
  { _id: "DRIVER", value: "DRIVER", name: "driver" },
  { _id: "COMPANY", value: "COMPANY", name: "company" },
  { _id: "PASSENGER", value: "PASSENGER", name: "parent" },
  {
    _id: "SUPER_AGENT_SCHOOL",
    value: "SUPER_AGENT_SCHOOL",
    name: "superAgent",
  },
  {
    _id: "BANK_SCHOOL",
    value: "BANK_SCHOOL",
    name: "bank",
  },
  {
    _id: "COMMISSION_MANAGER_SCHOOL",
    value: "COMMISSION_MANAGER_SCHOOL",
    name: "accounting_unit",
  },
];

export const PAYER_TYPE = [
  { _id: "DRIVER", value: "DRIVER", name: "driver" },
  { _id: "PASSENGER", value: "PASSENGER", name: "parent" },
  { _id: "COMPANY", value: "COMPANY", name: "company" },
  {
    _id: "SUPER_AGENT_SCHOOL",
    value: "SUPER_AGENT_SCHOOL",
    name: "superAgent",
  },
  { _id: "TAX", value: "TAX", name: "tax" },
  { _id: "BANK_SCHOOL", value: "BANK_SCHOOL", name: "bank" },
  {
    _id: "COMMISSION_MANAGER_SCHOOL",
    value: "COMMISSION_MANAGER_SCHOOL",
    name: "commission",
  },
];
export const TICKET_STATUS = [
  { _id: "IN_PROGRESS", value: "IN_PROGRESS", name: "pending" },
  { _id: "CLOSED", value: "CLOSED", name: "closed" },
  { _id: "ANSWERED", value: "ANSWERED", name: "answered" },
];

export const ticketUserType = [
  {
    _id: "ADMIN",
    name: "senjedExpert",
  },
  {
    _id: "GOVERNMENTSHIP",
    name: "governmentShip",
  },
  {
    _id: "PROVINCE_EDUCATION",
    name: "provinceEducation",
  },
  {
    _id: "SUPER_AGENT_SCHOOL",
    name: "cityEducation",
  },
  {
    _id: "MUNICIPALITY",
    name: "municipality",
  },
  {
    _id: "COMPANY",
    name: "company",
  },
  {
    _id: "DRIVER",
    name: "driver",
  },
  {
    _id: "PASSENGER",
    name: "parent",
  },
];
export const OFFLINE_PAYER_TYPE: IItem[] = [
  // { name: "driver", value: "DRIVER" },
  { name: "parent", value: "PASSENGER" },
];
export const DRIVER_OFFLINE_PAYER_TYPE: IItem[] = [
  { name: "driver", value: "DRIVER" },
  // { name: "parent", value: "PASSENGER" },
];
export const OFFLINE_PAYER_WAY: IItem[] = [
  { name: "Deposit_to_the_account", value: "TRANSFER" },
  { name: "pos", value: "POS_MACHINE" },
  { name: "card_by_card", value: "CARD_BY_CARD" },
];

export const STATUS_PAY_TO_DRIVER: IItem[] = [
  { name: "accept", value: "ACCEPT" },
  { name: "reject", value: "REJECT" },
  { name: "sendToBank", value: "SEND_TO_BANK" },
];
export const STATUS_PAY_TO_COMPANY: IItem[] = [
  { name: "accept", value: "SUCCESS" },
  { name: "reject", value: "REJECT" },
  { name: "sendToBank", value: "SEND2BANK" },
];
export const BLOCK_REASON: IItem[] = [
  { name: "blocked_by_admin", value: 2017 },
];
export const DEBT_USER_TYPE: IItem[] = [
  {
    _id: "COMPANY",
    name: "company",
  },
  {
    _id: "SUPER_AGENT_SCHOOL",
    name: "superAgent ",
  },
  {
    _id: "DRIVER",
    name: "driver",
  },
];

export const CAR_MODAL = Array.from({ length: 43 }, (_, i) => {
  const this_year = Number(
    convertGregorianToJalali({
      date: new Date().toDateString(),
      format: "jYYYY",
    })
  );
  const value = this_year - i;
  return { _id: value, name: value.toString(), value };
});

export const SETTELMENT_FILTER = Array.from({ length: 2 }, (_, i) => {
  const thisYear = Number(
    convertGregorianToJalali({
      date: new Date().toDateString(),
      format: "jYYYY",
    })
  );
  const value = thisYear - i;
  return { _id: value, name: value.toString(), value };
});

export const MONTH: IItem[] = [
  {
    _id: "1",
    name: "فروردین",
  },
  {
    _id: "2",
    name: "اردیبهشت ",
  },
  {
    _id: "3",
    name: "خرداد",
  },
  {
    _id: "4",
    name: "تیر",
  },
  {
    _id: "5",
    name: "مرداد",
  },
  {
    _id: "6",
    name: "شهریور",
  },
  {
    _id: "7",
    name: "مهر",
  },
  {
    _id: "8",
    name: "آبان",
  },
  {
    _id: "9",
    name: "آذر",
  },
  {
    _id: "10",
    name: "دی",
  },
  {
    _id: "11",
    name: "بهمن",
  },
  {
    _id: "12",
    name: "اسفند",
  },
];
